import clsx from 'clsx'
import { formatDistanceToNow } from 'date-fns'

import { Tag } from '@pepper/ui'

import { ReactComponent as ApprovalPendingIcon } from 'assets/images/status/approval-pending.svg'
import { ReactComponent as ApprovedIcon } from 'assets/images/status/approved.svg'
import { ReactComponent as InProgressIcon } from 'assets/images/status/in-progress.svg'
import { ReactComponent as NewIcon } from 'assets/images/status/new.svg'
import { ReactComponent as RejectedIcon } from 'assets/images/status/rejected.svg'
import { ReactComponent as OnHoldIcon } from 'assets/images/status/on-hold.svg'
import { ReactComponent as ScrappedIcon } from 'assets/images/status/scrapped.svg'

import PepperBlack from 'assets/images/pepper_icon_black.png'

import s from './StatusTag.module.css'

type StatusTagProps = {
  stage: AssignmentStage | ''
  client_approval_deadline: string | null
  children: JSX.Element
}

const StatusTag = ({
  stage,
  client_approval_deadline,
  children,
}: StatusTagProps): JSX.Element => {
  switch (stage) {
    case 'approved': {
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.green)}>
            <ApprovedIcon />
            <span>Approved</span>
          </Tag>
          {children}
        </div>
      )
    }

    case 'new': {
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.cyan)}>
            <NewIcon />
            <span>New</span>
          </Tag>
          {children}
        </div>
      )
    }
    case 'in_progress': {
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.cyan)}>
            <InProgressIcon />
            <span>In Progress</span>
          </Tag>
          {children}
        </div>
      )
    }

    case 'rejected': {
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.magenta)}>
            <RejectedIcon />
            <span>Rejected</span>
          </Tag>
          {children}
        </div>
      )
    }

    case 'hold': {
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.yellow)}>
            <OnHoldIcon />
            <span>On Hold</span>
          </Tag>
          {children}
        </div>
      )
    }

    case 'scrapped':
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.gray)}>
            <ScrappedIcon />
            <span>Scrapped</span>
          </Tag>
          {children}
        </div>
      )

    case 'finished':
    case 'approval_pending':
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.yellow)}>
            <ApprovalPendingIcon />
            {client_approval_deadline ? (
              <span>
                Approval due in{' '}
                {formatDistanceToNow(new Date(client_approval_deadline))}
              </span>
            ) : (
              <span>Approval Pending</span>
            )}
          </Tag>
          {children}
        </div>
      )

    case 'rework':
      return (
        <div className={s.orderStatus}>
          <img src={PepperBlack} alt="Pepper Creator" height={18} />
          <Tag className={clsx(s.tag, s.yellow)}>
            <InProgressIcon />
            <span>Rework</span>
          </Tag>
          {children}
        </div>
      )

    default:
      return <></>
  }
}

export default StatusTag
